export default "__VITE_ASSET__bf8bbc95__"